// @ts-nocheck
import styled from 'styled-components';

export const ButtonLink = styled.button.attrs(() => ({ type: 'button' }))`
  color: #0052cc;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: inherit;

  &:hover,
  &:active {
    text-decoration: underline;
  }
`;
